import React, {useEffect, useRef, useState} from 'react'
import {landingWithoutWizard} from '../../../utils/const'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import Input from '@material-ui/core/Input'
import MenuItem from '@material-ui/core/MenuItem'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import Select from '@material-ui/core/Select'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import useTheme from '@material-ui/styles/useTheme'

import get from 'lodash/get'
import {useStyles} from './OrganizationalFormStyle'
import {isNull, mobileValidation} from '../../../utils/validations'
import {fixNumbers, isNumber} from '../../../utils/numbers'
import {useDispatch, useSelector} from 'react-redux'
import {organizationalCreate} from '../actions'

const OrganizationalContent = () => {
    const classes = useStyles()
    const theme = useTheme()
    const dispatch = useDispatch()
    const offlineTypes = useSelector(state => state.dynamicConfig.organizational_types)
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    const [mobile, setMobile] = useState('')
    const [selectedType, setSelectedType] = useState(get(offlineTypes, '[0].name'))
    const [name, setName] = useState('')
    const [clicked, setClicked] = useState('')
    const [status, setStatus] = useState(null)
    const [showErrors, setShowErrors] = useState(false)

    const nameRef = useRef()
    const form = useRef()
    const successMessage = useRef()
    const faillureMessage = useRef()

    const ORGANIZATIONAL = landingWithoutWizard.ORGANIZATIONAL.name_en

    const onSelectInsurance = e => {
        showErrors && setShowErrors(false)
        let val
        if (e !== undefined) {
            val = e.target.value
            setSelectedType(val)
        }
    }

    const onMobileChange = e => {
        showErrors && setShowErrors(false)
        const val = e.target.value
        if (isNumber(val) && val.length <= 11) {
            setMobile(fixNumbers(val))
        }
    }

    const onNameChange = e => {
        showErrors && setShowErrors(false)
        const val = e.target.value
        setName(val)
    }

    if (!clicked) {
        successMessage && successMessage.current && (successMessage.current.style.display = 'none')
        faillureMessage &&
            faillureMessage.current &&
            (faillureMessage.current.style.display = 'none')
    }

    useEffect(() => {
        if (status && status.status === 201) {
            setTimeout(() => {
                form.current.style.display = 'none'
                successMessage.current.style.display = 'block'
                successMessage.current.style.transition = '1.5s'
                setTimeout(() => {
                    successMessage.current.style.opacity = 1
                }, [1000])
            }, 1000)
        } else if (status && showErrors) {
            setTimeout(() => {
                form.current.style.display = 'none'
                faillureMessage.current.style.display = 'block'
                faillureMessage.current.style.transition = '1.5s'
                setTimeout(() => {
                    faillureMessage.current.style.opacity = 1
                }, [1000])
            }, 1000)
        }
    }, [status, form])

    const onConfirm = () => {
        setClicked(true)
        if (mobileValidation(mobile)) {
            dispatch(
                organizationalCreate(
                    {
                        type: 'organization-req',
                        company_name: name,
                        cell_num: mobile,
                        insurance_type: selectedType,
                    },
                    setStatus,
                ),
            )
            form.current.className = classes.transitionOut
        } else {
            setShowErrors(true)
        }
    }

    return (
        <section className={classes.formBox}>
            <div className={classes.formTitle}>درخواست خرید بیمه سازمانی</div>

            <div className={classes.transitionIn} ref={successMessage}>
                درخواست شما با موفقیت ثبت شد.
                <br />
                منتظر تماس کارشناسان ما باشید.
            </div>

            <div className={classes.transitionInFailed} ref={faillureMessage}>
                درخواست شما با خطا روبرو شد.
            </div>

            <div className={classes.form} ref={form}>
                <FormControl className={classes.formRows}>
                    <FormLabel className={classes.label}>نوع بیمه</FormLabel>
                    <Select
                        className={classes.input}
                        onChange={e => {
                            onSelectInsurance(e)
                        }}
                        displayEmpty={true}
                        defaultValue={get(offlineTypes, '[0].name')}
                        variant={!isMobile ? 'outlined' : 'standard'}
                        required
                        error={showErrors && isNull(selectedType)}
                        MenuProps={{
                            getContentAnchorEl: null,
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'right',
                            },
                        }}>
                        {offlineTypes &&
                            offlineTypes.map((el, i) => (
                                <MenuItem className={classes.menuItem} key={i} value={el.name}>
                                    {el.label}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
                <FormControl
                    className={classes.formRows}
                    error={showErrors && !mobileValidation(mobile)}>
                    <FormLabel className={classes.label}>موبایل</FormLabel>
                    {!isMobile ? (
                        <OutlinedInput
                            placeholder="09370000000"
                            className={classes.input}
                            onChange={onMobileChange}
                            value={mobile}
                            onKeyPress={e => {
                                if (e.key === 'Enter') {
                                    e.preventDefault()
                                    nameRef && nameRef.current && nameRef.current.firstChild.focus()
                                }
                            }}
                        />
                    ) : (
                        <Input
                            placeholder="09370000000"
                            className={classes.input}
                            onChange={onMobileChange}
                            value={mobile}
                        />
                    )}
                </FormControl>
                <FormControl className={classes.formRows}>
                    <FormLabel className={classes.label}>نام سازمان (اختیاری)</FormLabel>
                    {!isMobile ? (
                        <OutlinedInput
                            placeholder="نام کارگاه، شرکت، کارخانه یا ...)"
                            className={classes.input}
                            ref={nameRef}
                            onChange={onNameChange}
                            value={name}
                            onKeyPress={e => {
                                if (e.key === 'Enter') {
                                    e.preventDefault()
                                    onConfirm && onConfirm()
                                }
                            }}
                        />
                    ) : (
                        <Input
                            placeholder="نام کارگاه، شرکت، کارخانه یا ..."
                            className={classes.input}
                            onChange={onNameChange}
                            value={name}
                        />
                    )}
                </FormControl>

                <Button
                    className={classes.button}
                    onClick={onConfirm}
                    variant="contained"
                    color="secondary">
                    {landingWithoutWizard[ORGANIZATIONAL.toUpperCase()].content.button}
                </Button>
            </div>
        </section>
    )
}

export default OrganizationalContent
